import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './CwShellLeftNav.scss';
import CwImage from '../cwimage/CwImage';
import CwShellLeftNavButton from './cwshellleftnavbutton/CwShellLeftNavButton';
import {CwShellLeftNavExpand} from './constants';
import IconPath from 'src/utils/IconPath';

const CwShellLeftNav = (props) => {

  const cwShellLeftNavClass = cx(
    css.cwShellLeftNav,
    {
      [css.collapsed]: props.expand === CwShellLeftNavExpand.COLLAPSED,
      [css.default]: props.expand === CwShellLeftNavExpand.DEFAULT,
      [css.fat]: props.expand === CwShellLeftNavExpand.FAT
    }
  );

  const collapseIconClass = cx(
    css.expansionIcon,
    css.collapseIcon,
    {
      [css.fat]: props.expand === CwShellLeftNavExpand.FAT
    }
  );

  const expandIconClass = cx(
    css.expansionIcon,
    css.expandIcon,
    {
      [css.collapsed]: props.expand === CwShellLeftNavExpand.COLLAPSED
    }
  );

  const renderChildren = () => {
    return React.Children.map(props.children, child => {
      return React.cloneElement(child, {
        active: props.activeButton === child.props.id,
        activeLink: props.activeLink,
        collapseIcon: props.collapseIconUp,
        expandIcon: props.expandIconDown,
        expand: props.expand,
        setActiveButton: props.setActiveButton,
        setActiveLink: props.setActiveLink
      });
    });
  };

  return (
    <div
      className={cwShellLeftNavClass}
      style={props.style}
    >
      <div className={css.expansionIconContainer}>

        {/* Collapse Button */}
        {props.expand !== CwShellLeftNavExpand.COLLAPSED &&
        <CwImage
          className={collapseIconClass}
          src={props.collapseIconLeft}
          onClick={props.handleCollapse} />
        }

        {/* Expand Button */}
        {props.expand !== CwShellLeftNavExpand.FAT &&
        <CwImage
          className={expandIconClass}
          src={props.expandIconRight}
          onClick={props.handleExpand} />
        }
      </div>

      <div style={{clear: 'both'}}></div>

      {/* Rest of the content (hide if collapsed) */}
      {props.expand !== CwShellLeftNavExpand.COLLAPSED &&
      <div className={css.cwShellLeftNavContainer}>
        {renderChildren()}
      </div>
      }

    </div>
  );
};

CwShellLeftNav.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf([CwShellLeftNavButton])
    }),
    PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf([CwShellLeftNavButton])
    }))
  ]),
  /**
   * Id of active menu button
   */
  activeButton: PropTypes.number,
  /**
   * Id of active menu link
   */
  activeLink: PropTypes.number,
  /**
   * Determines the expansion style of the menu.
   */
  expand: PropTypes.oneOf([
    CwShellLeftNavExpand.COLLAPSED,
    CwShellLeftNavExpand.DEFAULT,
    CwShellLeftNavExpand.FAT
  ]),
  /**
   * Path to collapse icon (left nav expansion)
   */
  collapseIconLeft: PropTypes.string,
  /**
   * Path to collapse icon (sub menu expansion)
   */
  collapseIconUp: PropTypes.string,
  /**
   * Path to expand icon (left nav expansion)
   */
  expandIconRight: PropTypes.string,
  /**
   * Path to expand icon (sub menu expansion)
   */
  expandIconDown: PropTypes.string,
  /**
   * Callback function that is fired on collapse button press
   */
  handleCollapse: PropTypes.func,
  /**
   * Callback function that is fired on expand button press
   */
  handleExpand: PropTypes.func,
  /**
   * Callback function to set the active button
   */
  setActiveButton: PropTypes.func,
  /**
   * Callback function to set the active link
   */
  setActiveLink: PropTypes.func,
  /**
   * Allows custom styling
   */
  style: PropTypes.object,
};

CwShellLeftNav.defaultProps = {
  collapseIconLeft: IconPath.get('Action_Back'),
  collapseIconUp: IconPath.get('Action_CollapseUp'),
  expandIconRight: IconPath.get('Action_Forward'),
  expandIconDown: IconPath.get('Action_ExpandDown')
};

export default CwShellLeftNav;


// WEBPACK FOOTER //
// ./src/components/cwshellleftnav/CwShellLeftNav.jsx